var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form-accordion",
    { attrs: { title: _vm.configTitle, isTitleUpperCase: false } },
    [
      _c(
        "b-row",
        [
          _vm.isEditable
            ? _c("b-col", { staticClass: "form-group", attrs: { cols: "6" } }, [
                _c("label", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("common.routing.config_type")) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.configType,
                        expression: "configType",
                      },
                    ],
                    staticClass: "form-control",
                    on: {
                      change: [
                        function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.configType = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        function ($event) {
                          /*emptyFields*/
                        },
                      ],
                    },
                  },
                  _vm._l(_vm.configTypeList, function (config) {
                    return _c(
                      "option",
                      { key: config.id, domProps: { value: config.value } },
                      [
                        _vm._v(
                          "\n          " + _vm._s(config.name) + "\n        "
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ])
            : _c(
                "b-col",
                { staticClass: "form-group", attrs: { cols: "6" } },
                [
                  _c("form-read-group-label-input", {
                    attrs: {
                      inputLabel: _vm.$t("common.routing.config_type"),
                      inputValue: _vm.configType,
                    },
                  }),
                ],
                1
              ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.configType === "MQSERIES"
        ? _c("mq-series-configuration-form", {
            model: {
              value: _vm.configMQSeries,
              callback: function ($$v) {
                _vm.configMQSeries = $$v
              },
              expression: "configMQSeries",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.configType === "WEBSERVICE"
        ? _c("web-service-configuration-form", {
            model: {
              value: _vm.configWebService,
              callback: function ($$v) {
                _vm.configWebService = $$v
              },
              expression: "configWebService",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }